import React, { useState } from "react";
import MarketingLayout, { Seo, PageHero, FinalCta } from "@/components/marketing/MarketingLayout";
import { FAQS } from "@/lib/marketingSite";
import { CaretDown } from "@phosphor-icons/react";

const FaqItem = ({ item, index }) => {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className="card-matte overflow-hidden">
      <button data-testid={`faq-item-${index}`} onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left">
        <span className="font-head font-semibold text-white">{item.q}</span>
        <CaretDown size={18} className={`shrink-0 brand-text transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={`px-5 text-[#9a9a9a] text-sm leading-relaxed transition-all duration-300 ${open ? "max-h-60 pb-5 opacity-100" : "max-h-0 opacity-0"}`}>
        {item.a}
      </div>
    </div>
  );
};

export default function FaqPage() {
  return (
    <MarketingLayout>
      <Seo title="FAQ & Documentation — Vozelto" path="/faq"
        description="Answers to common Vozelto questions: how the AI Monthly Planner works, approval workflow, Facebook & Instagram publishing, Shopify integration, pricing and trials." />
      <PageHero caps="FAQ & documentation" title={<>Questions,<br /><span className="brand-text">answered.</span></>}
        subtitle="Everything you need to know before starting your trial. Can't find your answer? Email support@vozelto.com or use the contact page." />
      <section className="max-w-3xl mx-auto px-5 pb-16">
        <div className="space-y-3" data-testid="faq-list">
          {FAQS.map((item, i) => <FaqItem key={i} item={item} index={i} />)}
        </div>
      </section>
      <FinalCta title="Still Curious? Try It Yourself." sub="The 14-day trial answers questions faster than any FAQ." />
    </MarketingLayout>
  );
}
